import React from 'react';

const SearchIcon: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='19'
      height='18'
      viewBox='0 0 19 18'
      fill='none'
      className='stroke-current text-primary-300 dark:text-primary-500'
    >
      <path
        d='M17.375 16.875L12.8276 12.3276M12.8276 12.3276C14.0583 11.0969 14.7498 9.42761 14.7498 7.68706C14.7498 5.94651 14.0583 4.27725 12.8276 3.0465C11.5968 1.81574 9.92756 1.12431 8.18701 1.12431C6.44647 1.12431 4.77721 1.81574 3.54645 3.0465C2.3157 4.27725 1.62427 5.94651 1.62427 7.68706C1.62427 9.42761 2.3157 11.0969 3.54645 12.3276C4.77721 13.5584 6.44647 14.2498 8.18701 14.2498C9.92756 14.2498 11.5968 13.5584 12.8276 12.3276Z'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default SearchIcon;
